import { AbTestDto } from 'types/dtos'

import { stateName } from './constants'
import { AllState, State } from './types'

const localState = (state: AllState): State => state[stateName]

export const getAbTestByName =
  (name: string) =>
  (state: AllState): AbTestDto | undefined =>
    localState(state)[name]

export const getIsAbTestVariant =
  (name: string, variant: string) =>
  (state: AllState): boolean =>
    getAbTestByName(name)(state)?.variant === variant

export const getIsAbTestOn =
  (name: string) =>
  (state: AllState): boolean =>
    getIsAbTestVariant(name, 'on')(state)
